import { fetch } from '@/shared/fetch';
import { IApproximateWaitingTimeResponse } from '@/shared/interfaces';
import { ConsultationTypeEnum } from '@/shared/enums';

export const fetchHasBlockingConsultation = async (
    patientUid: string,
    consultationType: ConsultationTypeEnum,
) => {
    return await fetch<boolean>(
        `/api/patients/${patientUid}/has-blocking-video-consultation/${consultationType}`,
        'GET',
    );
};
